import EventCreator from './event-creator';

export default EventCreator;